module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/02_shape-sm-838b3fba8a3997f1f3dcba68abf3af25.png";